module.exports = __webpack_public_path__ + "img/Buro.9cc10319.svg";